import { Dialog } from 'components/Dialog';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { filterArrayEmpty } from 'lib/riskbase';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import reactStringReplace from 'react-string-replace';
import { CLEAR_CONFIRM } from 'store/app/actions';
import { selectConfirm } from 'store/app/selectors';

export const DialogConfirm: React.FC = () => {
  const dispatch = useDispatch();
  const confirm = useSelector(selectConfirm);

  if (!confirm) {
    return null;
  }

  const handleCancel = () => {
    dispatch(CLEAR_CONFIRM());
    dispatch(confirm.onCancel);
  };

  const handleConfirm = () => {
    dispatch(CLEAR_CONFIRM());
    dispatch(confirm.onConfirm);
  };

  const handleAltConfirm = () => {
    dispatch(CLEAR_CONFIRM());
    if (confirm.onAltConfirm) {
      dispatch(confirm.onAltConfirm);
    }
  };

  const bold = /\*(.*?)\*/gm;
  const text = (
    <Txt size="normal">
      {reactStringReplace(confirm.text, bold, (match, i) => (
        <Txt key={i} size="normal" weight="bold">
          {match}
        </Txt>
      ))}
    </Txt>
  );

  return (
    <Dialog
      title={confirm.title}
      subtitle={confirm.subtitle}
      titleStyle={
        confirm.titleColor ? { color: confirm.titleColor } : undefined
      }
      titleIcon={confirm.titleIcon}
      titleIconColor={
        confirm.titleIconColor ||
        (confirm.destructive ? theme.colors.red : undefined)
      }
      text={text}
      buttons={[
        { onPress: handleCancel, text: confirm.cancelText || '' },
        confirm.onAltConfirm
          ? {
              onPress: handleAltConfirm,
              text: confirm.altConfirmText || 'AltConfirm',
              textStyle: confirm.altColor
                ? { color: confirm.altColor }
                : undefined,
            }
          : null,
        {
          onPress: handleConfirm,
          text: confirm.confirmText || '',
          icon: confirm.confirmIcon,
          destructive: confirm.destructive,
          initDisabled: confirm.delayedConfirm,
        },
      ].filter(filterArrayEmpty)}
      onDismiss={confirm.dismissable !== false ? handleCancel : undefined}
    />
  );
};
